import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Table, Icon } from 'semantic-ui-react'
import TableRow from './EstimateMaterialTableRow'

class BillOfMaterials extends Component {
  state = {}
  render() { 
    return (
      <Table striped compact='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Material</Table.HeaderCell>
            <Table.HeaderCell>Units Required</Table.HeaderCell>
            <Table.HeaderCell>Unit Cost</Table.HeaderCell>
            <Table.HeaderCell>Total Cost</Table.HeaderCell>
            {!this.props.noEdit && <Table.HeaderCell />}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.props.estimate.bom.map((item, index) => (
            <TableRow key={index} item={item} noEdit={this.props.noEdit} />
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={3}>
              {!this.props.noEdit &&
                <a href='#recalculate-bom' onClick={this.props.estimate.recalculateBom}>
                  <Icon name='refresh' /> Re-calculate
                </a>
              }
            </Table.HeaderCell>
            <Table.HeaderCell><strong>${this.props.estimate.sumMaterials().toFixed(2)}</strong></Table.HeaderCell>
            {!this.props.noEdit && <Table.HeaderCell />}
          </Table.Row>
        </Table.Footer>
      </Table>
    )
  }
}
 
export default observer(BillOfMaterials);




// WEBPACK FOOTER //
// ./src/components/jobs/EstimateMaterialTable.js